import { Box } from '@mui/material'
import { green, orange, red } from '@mui/material/colors'

type AccuracyColorBarProps = {
  percentage?: number
}

export const colorMap: [number, string][] = [
  [50, green['500']],
  [30, orange['A400']],
  [20, red['A400']],
]

export default function PercentageColorBar({
  percentage,
}: AccuracyColorBarProps) {
  const color =
    colorMap.find(([threshold]) => (percentage || 0) >= threshold)?.[1] || 'red'

  return (
    <Box
      sx={{
        background: color,
        width: percentage ? `${Math.floor(percentage)}%` : 0,
        height: 8,
        borderRadius: '0 8px 8px 0',
      }}
    />
  )
}
